/**
 * @desc: 用户地图
 */
import request from '@/plugins/http'
import qs from 'qs'

// 获取商户、供应商地址坐标点
export const getPointList = params => {
  return request.get('/merchant/usermap/getPointList', params)
}

//获取所有业务开展城市
export const getAllCity = data => {
  return request.post('/merchant/usermap/getCityListByCompanyId', qs.stringify(data))
}